import api from '../api/axiosInstance';

export const GuardarReciboService= async (data) => {
    try {
        const response = await api.post('/recibo/generar-recibo', data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error desconocido al imprimir'};
    }
};